import { MapPin, X } from 'lucide-react'
import PhotoGallery from './PhotoGallery'

export default function PlaceDrawer({ point, trip, photos = [], onClose }) {
  if (!point) return null
  return (
    <aside className="country-drawer place-drawer" aria-live="polite">
      <button className="icon-button country-drawer__close" onClick={onClose} aria-label="Close place details"><X size={18} /></button>
      {photos.length > 0 ? (
        <PhotoGallery photos={photos} compact />
      ) : (
        <div className="place-drawer__empty-photo"><MapPin size={32} /><span>No photos here yet</span></div>
      )}
      <div className="country-drawer__body">
        <div className="eyebrow">{trip?.name || 'Route location'}</div>
        <h2>{point.label}</h2>
        <p className="photo-location-line"><MapPin size={14} /> {Number(point.latitude).toFixed(5)}, {Number(point.longitude).toFixed(5)}</p>
        <div className="detail-grid">
          <div><span>{point.kind || 'location'}</span></div>
          <div><span>Stop {point.position}</span></div>
          <div><span>{photos.length} photo{photos.length === 1 ? '' : 's'}</span></div>
        </div>
      </div>
    </aside>
  )
}
